/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconPlaybackSpeed1Point8x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M14.27 4.142a2.17 2.17 0 0 0 .585-1.495c0-1.372-1.2-2.32-2.577-2.32-1.387 0-2.558.957-2.558 2.32 0 .586.217 1.097.574 1.49-.54.426-.902 1.04-.902 1.79 0 1.506 1.457 2.46 2.886 2.46 1.43 0 2.887-.954 2.887-2.46 0-.747-.36-1.359-.896-1.785zm-1.992-2.316c.741 0 1.077.458 1.077.82 0 .364-.336.821-1.077.821-.73 0-1.058-.448-1.058-.82 0-.373.328-.82 1.058-.82zm0 3.141c.93 0 1.387.577 1.387.96 0 .384-.457.96-1.386.96-.93 0-1.387-.576-1.387-.96 0-.383.457-.96 1.386-.96zM4.491.695c0 .307-.346.762-1.044.762h-.276v1.5h1.32V8h1.5V.695h-1.5zm10.818 9.835-1.97 1.97 1.97 1.97-1.06 1.06-1.97-1.97-1.97 1.97-1.06-1.06 1.969-1.97-1.97-1.97 1.06-1.06 1.97 1.97 1.97-1.97 1.06 1.06zM8.085 8.42a.956.956 0 1 0 0-1.913.956.956 0 0 0 0 1.913z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M22.008 4.219c0 .968-.398 1.802-1.04 2.414.915.654 1.535 1.634 1.535 2.835 0 2.26-2.197 3.737-4.418 3.737-2.22 0-4.418-1.477-4.418-3.737 0-1.205.625-2.187 1.545-2.842a3.307 3.307 0 0 1-1.02-2.407c0-2.048 1.76-3.513 3.893-3.513 2.118 0 3.923 1.453 3.923 3.513zm-5.816 0c0 .728.637 1.513 1.893 1.513 1.27 0 1.923-.798 1.923-1.513 0-.715-.653-1.513-1.923-1.513-1.256 0-1.893.785-1.893 1.513zm-.525 5.25c0 .762.864 1.736 2.418 1.736 1.555 0 2.418-.974 2.418-1.737 0-.763-.863-1.736-2.418-1.736-1.554 0-2.418.973-2.418 1.736zm6.375 7.128L19.5 19.14l2.543 2.543-1.414 1.414-2.543-2.543-2.543 2.543-1.414-1.415 2.543-2.542-2.543-2.543 1.414-1.415 2.543 2.543 2.543-2.543 1.414 1.415zm-9.343-4.883a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0zM7.002.985c0 .634-.679 1.42-1.87 1.42h-.443v2h2.313v8.269h2V.985h-2z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed1Point8x is deprecated and will be archived soon. Use IconPlaybackSpeed1Point8x instead.
 */
export function Experimental__IconPlaybackSpeed1Point8x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed1Point8x, props);
}